import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

const ticketRoutes = [
	{
		component: LazyComponent(lazy(() => import('./List'))),
		path: '/ticket/list',
	},
];

export default ticketRoutes;
